<script lang="ts">
      import { formatDate, getLocaleDay } from '$lib/utils/date'
      import { untrack } from 'svelte'
      import { getLocaleContext } from '../locale/ts/Locale.svelte'
      import { getMetaContext } from '../metatags/ts/MetaContext.svelte'
      import CatalogueListItem from './CatalogueListItem.svelte'
      import ProgramListItem from './ProgramListItem.svelte'

      let { items } = $props()
      const meta = getMetaContext()
      const locale = getLocaleContext()

      let _items = $derived.by(() => {
            const _items = items.filter(i => i.program == "inscenation").map((i: any) => i).sort( (a,b) => (a.title_cs as string).localeCompare(b.title_cs))
            return _items
      })

      $effect( () => {
        items
        untrack( () => {
          meta.setMeta({
            title: locale.ŧ({default: "Inscenace A-Z", en: "Inscenations A-Z"}),
          })
        })
      })

      console.log(items)
</script>

<div class="w-full flex flex-col gap-16">
      <div class="program-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full gap-4">
            {#each _items as item, i (item.id)}
                  <CatalogueListItem {item}></CatalogueListItem>
            {/each}
      </div>
</div>

<style lang="postcss">
            .program-grid {
            @screen md {
                  grid-auto-rows: 1fr;
            }
      }
</style>
